export default {
  internalRequest: {
    itself: 'Cerere internă',
    plural: {
      itself: 'Cereri interne',
    },
    createNewRequest: 'Creează cerere internă nouă',
    saveRequest: 'Salvează cererea internă',
    backToList: 'Înapoi la listă',
    nextStep: 'Următorul pas',
    saveAsDraft: 'Salvează ca draft',
    submitForApproval: 'Trimite pentru aprobare',
    validationErrors: 'Te rugăm să verifici câmpurile marcate cu roșu.',
    calculatedHint: 'Calculat automat',
    createRequest: 'Creează cerere {{type}}',
    selectType: {
      itself: 'Tip cerere',
      placeholder: 'Selectează tipul cererii',
      required: 'Tipul cererii este obligatoriu',
    },
    attributes: {
      project: 'Proiect',
      requestType: 'Tip cerere',
      title: {
        itself: 'Titlu',
        required: 'Titlul este obligatoriu',
        placeholder: 'ex., Materiale de birou pentru Octombrie',
      },
      additionalNote: {
        itself: 'Notă suplimentară',
        placeholder: 'Furnizează note suplimentare despre această cerere...',
      },
      amount: {
        itself: 'Sumă',
      },
      currency: {
        itself: 'Monedă',
        placeholder: 'Selectează o opțiune',
      },
      neededBy: {
        itself: 'Necesar până la',
        placeholder: 'dd/mm/yyyy',
      },
      costCategory: {
        itself: 'Categorie cost',
        placeholder: 'Selectează categoria de cost',
        travel: 'Călătorie',
        accommodation: 'Cazare',
        materials: 'Materiale',
        services: 'Servicii',
        equipment: 'Echipament',
        other: 'Altele',
      },
      linkedTicket: {
        itself: 'Tichet',
        placeholder: 'Selectează tichet (opțional)',
      },
      linkedProcurement: {
        itself: 'Achiziție',
        placeholder: 'Selectează achiziție (opțional)',
      },
      assignedTo: {
        itself: 'Asignat către',
        placeholder: 'Selectează utilizator HQ',
        required: 'Asignarea către utilizator HQ este obligatorie',
      },
      attachments: {
        itself: 'Atașamente',
        upload: 'Încarcă atașamente',
        required: 'Cel puțin un atașament este obligatoriu',
      },
      status: {
        draft: 'Draft',
        submitted: 'Trimis',
        opened: 'Trimis',
        approved: 'Aprobat',
        pendingClosed: 'În curs de închidere',
        rejected: 'Respins',
        closed: 'Închis',
        all: 'Toate',
      },
      type: {
        expenseReimbursement: 'Decont de cheltuieli',
        interestFreeLoan: 'Împrumut',
        cashAdvance: 'Avans',
        extraWorkApproval: 'Referat',
        overtimeWorkRequest: 'Cerere ore suplimentare',
        materialsRequest: 'Cerere materiale',
        leaveRequest: 'Cerere concediu',
        financialRequest: 'Cerere financiară',
      },
    },
    table: {
      requestId: 'ID cerere',
      project: 'Proiect',
      type: 'Tip',
      title: 'Titlu',
      status: 'Status',
      amount: 'Sumă',
      createdBy: 'Creat de',
      date: 'Data',
      approver: 'Aprobator',
      created: 'Creat',
      opened: 'Deschis',
      updated: 'Actualizat',
    },
    filters: {
      status: 'Status',
      allTypes: 'Toate Tipurile',
    },
    types: {
      expenseReimbursement: {
        title: 'Decont de cheltuieli',
        description:
          'Trimite cheltuieli pentru rambursare. Necesită încărcarea chitanțelor sau facturilor.',
      },
      interestFreeLoan: {
        title: 'Împrumut',
        description:
          'Solicită un împrumut fără dobândă. Supus aprobării și termenilor de rambursare.',
      },
      cashAdvance: {
        title: 'Avans',
        description:
          'Solicită un avans pentru călătorii sau lucrări pe șantier.',
      },
      extraWorkApproval: {
        title: 'Referat',
        description:
          'Solicită aprobare pentru lucrări sau servicii suplimentare.',
      },
      overtimeWorkRequest: {
        title: 'Cerere ore suplimentare',
        description:
          'Solicită aprobare pentru lucrări suplimentare și de weekend.',
      },
      materialsRequest: {
        title: 'Cerere materiale',
        description: 'Solicită materiale și resurse pentru proiect.',
      },
      financialRequest: {
        title: 'Cerere financiară',
        description:
          'Trimite o cerere financiară: împrumut, avans salariu sau bonus recrutare.',
        subType: 'Sub-tip',
        subTypes: {
          loanRequest: 'Cerere împrumut',
          salaryAdvance: 'Avans salariu',
          recruitmentBonus: 'Bonus recrutare',
        },
        requestedAmount: 'Suma solicitată',
        forMonth: 'Pe luna',
        numberOfInstallments: 'Număr de rate lunare',
        monthlyInstallmentAmount: 'Rata lunară',
        referredPersonName: 'Numele persoanei recomandate',
        referredPersonRole: 'Rolul persoanei recomandate',
        bonusAmount: 'Suma bonus',
        monthsLabel: 'luni',
        repaymentEndDate: 'Ultima rată',
      },
      leaveRequest: {
        title: 'Cerere concediu de odihnă',
        description:
          'Trimite o cerere de concediu de odihnă cu detalii angajat și perioadă.',
        employeeLastName: 'Nume',
        employeeFirstName: 'Prenume',
        employeeRole: 'Funcție',
        numberOfDays: 'Număr de zile',
        periodStart: 'Data de început',
        periodEnd: 'Data de sfârșit',
        replacementPerson: 'Înlocuitor',
        approvedDays: 'Zile aprobate',
        annualLeaveDays: 'Zile CO anuale',
        usedLeaveDays: 'Zile CO efectuate',
        remainingLeaveDays: 'Zile CO rămase',
        approverNotes: 'Mențiuni aprobator',
        employeeName: 'Numele angajatului',
        daysUnit: 'zile',
        selectFromProject: 'Selectează din proiect',
        enterManually: 'Completează manual',
        employee: 'Angajat',
      },
    },
    expenseReimbursement: {
      title: 'Detalii cheltuieli',
      subtitle: 'Decontare cheltuieli efectuate',
      claimPeriodStart: {
        itself: 'Data început',
        placeholder: 'Selectează data de început',
        required: 'Data de început este obligatorie',
      },
      claimPeriodEnd: {
        itself: 'Data sfârșit',
        placeholder: 'Selectează data de sfârșit',
        invalid: 'Data de sfârșit trebuie să fie după data de început',
        required: 'Data de sfârșit este obligatorie',
      },
      paymentMethod: {
        itself: 'Metodă de plată',
        placeholder: 'Selectează metoda de plată',
        companyCard: 'Card companie',
        personalCashCard: 'Card / numerar personal',
        companyCash: 'Numerar companie',
      },
      expenseItems: 'Cheltuieli',
      addLineItem: 'Adaugă cheltuială',
      totalExpenses: 'Total cheltuieli',
      advanceAmount: {
        itself: 'Sumă avans',
        min: 'Suma avans nu poate fi negativă',
      },
      toReceive: 'De primit',
      toReturn: 'De returnat',
      settlement: {
        itself: 'Decontare',
        toReceive: 'De primit (rambursare)',
        toReturn: 'De returnat (fonduri nefolosite)',
      },
      notes: 'Note adiționale',
      notesPlaceholder: 'Adaugă note sau observații...',
      table: {
        docNumber: 'Nr. Doc',
        date: 'Data',
        issuer: 'Emitent',
        issuerPlaceholder: 'Nume furnizor',
        description: 'Descriere',
        descriptionPlaceholder: 'Descriere',
        unitOfMeasure: 'U.M.',
        unitOfMeasurePlaceholder: 'buc',
        quantity: 'Cant.',
        unitPrice: 'Preț unitar',
        amount: 'Sumă ',
      },
      lineItems: {
        required: 'Cel puțin o cheltuială este obligatorie',
      },
      lineItemAttachments: 'Atașamente',
      documentNumber: {
        required: 'Numărul documentului este obligatoriu',
        numbersOnly: 'Sunt permise doar cifre',
      },
      documentDate: {
        required: 'Data este obligatorie',
      },
      issuer: {
        required: 'Emitentul este obligatoriu',
      },
      description: {
        required: 'Descrierea este obligatorie',
      },
      unitOfMeasure: {
        required: 'Unitatea de măsură este obligatorie',
      },
      quantity: {
        required: 'Cantitatea este obligatorie',
        min: 'Cantitatea trebuie să fie cel puțin 1',
      },
      unitPrice: {
        required: 'Prețul unitar este obligatoriu',
        positive: 'Prețul unitar trebuie să fie mai mare decât 0',
      },
      addExpenseItem: 'Adaugă element cheltuieli',
      editExpenseItem: 'Editează element cheltuieli',
      emptyState: {
        title: 'Nicio cheltuială încă',
        message: 'Adaugă prima cheltuială pentru a urmări decontul',
      },
    },
    interestFreeLoan: {
      title: 'Detalii împrumut',
      subtitle: 'Solicitare împrumut fără dobândă',
      requestedAmount: 'Suma solicitată',
      repaymentDurationMonths: 'Durata rambursare',
      durationHint: 'Numărul de luni în care va fi rambursat împrumutul',
      numberOfInstallments: 'Număr de rate lunare',
      monthlyInstallmentAmount: 'Rata lunară',
      installmentHint: 'rate lunare egale',
      startMonth: 'Data de început',
      startMonthPlaceholder: 'Selectează data de început',
      startMonthHint: 'Data de la care începe rambursarea',
      reason: 'Motiv',
      reasonPlaceholder:
        'Descrie motivul pentru care soliciți acest împrumut...',
      maxAmount: 'Sumă maximă: 10.000 RON',
      minDuration:
        'Minim 1 lună • Numărul de luni în care va fi rambursat împrumutul',
      overLimitWarning:
        'Suma solicitată depășește limita maximă de 10.000 RON!',
      totalLoan: 'Suma împrumutului',
      monthsLabel: 'luni',
    },
    cashAdvance: {
      title: 'Detalii avans',
      subtitle: 'Solicitare avans numerar pentru cheltuieli',
      purpose: {
        itself: 'Scop',
        placeholder: 'Selectează scopul',
        travel: 'Transport',
        accommodation: 'Cazare',
        perDiem: 'Diurnă',
        materials: 'Materiale',
      },
      location: {
        itself: 'Locație',
        placeholder: 'București, Cluj-Napoca...',
      },
      period: 'Perioada',
      startDate: {
        itself: 'Data început',
        placeholder: 'Selectează data de început',
      },
      endDate: {
        itself: 'Data sfârșit',
        placeholder: 'Selectează data de sfârșit',
      },
      beneficiaryPersons: {
        itself: 'Persoane beneficiare',
        placeholder: 'Ion Popescu, Maria Ionescu...',
      },
      beneficiaryPersonsHint: 'Separă numele cu virgulă',
      beneficiaryRoles: {
        itself: 'Funcții beneficiari',
        placeholder: 'Tehnician, Inginer...',
      },
      beneficiaries: {
        itself: 'Persoane beneficiare',
        name: 'Nume',
        namePlaceholder: 'Ion Popescu',
        role: 'Funcție',
        rolePlaceholder: 'Tehnician',
      },
      addBeneficiary: 'Adaugă persoană',
      amountPerPerson: 'Sumă per persoană',
      totalAmount: 'Sumă totală',
      totalHint: 'Calculat automat',
      totalAdvance: 'Total avans solicitat',
    },
    extraWorkApproval: {
      title: 'Detalii aprobare lucrări',
      subtitle: 'Aprobare lucrări suplimentare',
      subType: {
        label: 'Tip',
        required: 'Tipul este obligatoriu',
        overtimeHours: 'Ore suplimentare',
        financialItem: 'Element financiar',
      },
      hasFinancialItems: {
        label: 'Are elemente financiare',
      },
      beneficiaryEntity: {
        itself: 'Entitate beneficiară',
        placeholder: 'Numele beneficiarului / entității',
      },
      workDescription: {
        itself: 'Descriere lucrări',
        placeholder:
          'Descrie detaliat lucrările suplimentare care necesită aprobare...',
      },
      documents: 'Documente disponibile',
      hasEstimate: 'Deviz atașat',
      hasBeneficiaryApproval: 'Aprobare beneficiar',
      requestedTotalAmount: 'Sumă totală solicitată',
      requestedAmount: 'Sumă solicitată',
      approvedAmount: 'Sumă aprobată',
      attachmentsHint:
        'Atașează devizul, aprobarea beneficiarului și orice alte documente relevante pentru lucrările suplimentare.',
      workers: {
        itself: 'Muncitori',
        emptyState: {
          title: 'Niciun muncitor adăugat',
          message:
            'Adaugă primul muncitor pentru a urmări costurile cu forța de muncă',
        },
      },
      addWorker: 'Adaugă muncitor',
      table: {
        lastName: 'Nume',
        firstName: 'Prenume',
        role: 'Funcție',
        amount: 'Sumă',
      },
      financialData: {
        itself: 'Date financiare',
        emptyState: {
          title: 'Nicio dată financiară',
          message:
            'Adaugă date financiare pentru a urmări devizele și facturile',
        },
      },
      addFinancialItem: 'Adaugă element financiar',
      financial: {
        documentNumber: 'Nr. document',
        documentDate: 'Data document',
        documentNumberDate: 'Nr. document / Data',
        valueWithoutVat: 'Valoare (fără TVA)',
        invoiceNumber: 'Nr. factură',
        invoiceDate: 'Data factură',
        invoiceNumberDate: 'Nr. factură / Data',
        isInvoiced: 'Facturat',
        isCollected: 'Încasat',
        paymentStatus: 'Status plată',
        invoiced: 'Facturat',
        collected: 'Încasat',
      },
      totalWorkerAmount: 'Sumă totală',
      totalFinancialValue: 'Valoare totală (fără TVA)',
    },
    overtimeWorkRequest: {
      title: 'Detalii ore suplimentare',
      subtitle: 'Solicitare ore suplimentare / lucru în weekend',
      workDescription: {
        itself: 'Descriere activități',
        placeholder: 'Descrie activitățile care vor fi efectuate...',
      },
      period: 'Perioada',
      startDate: {
        itself: 'Data început',
        placeholder: 'Selectează data de început',
        required: 'Data de început este obligatorie',
      },
      endDate: {
        itself: 'Data sfârșit',
        placeholder: 'Selectează data de sfârșit',
      },
      periodHint: 'Pentru o singură zi, selectează aceeași dată',
      workDate: {
        itself: 'Data lucrărilor',
        placeholder: 'Selectează data',
      },
      hours: 'Ore',
      rate: 'Tarif',
      peopleList: {
        itself: 'Lista persoanelor',
        placeholder:
          'Lista persoanelor care vor lucra ore suplimentare:\n- Nume, funcție, ore, tarif\n- ...',
      },
      peopleListHint:
        'Introdu numele, funcția și orele pentru fiecare persoană',
      people: {
        itself: 'Lista persoanelor',
        name: 'Nume',
        namePlaceholder: 'Ion Popescu',
        role: 'Funcție',
        rolePlaceholder: 'Tehnician',
      },
      addPerson: 'Adaugă persoană',
      totalRequestedAmount: 'Total solicitat',
      totalHint: 'Calculat: Ore × Tarif',
      totalCost: 'Cost total estimat',
    },
    materialsRequest: {
      title: 'Detalii cerere materiale',
      subtitle: 'Solicitare materiale și resurse',
      lineItems: 'Lista materialelor',
      addLineItem: 'Adaugă material',
      itemCount: 'Articole',
      grandTotal: 'Valoare totală',
      table: {
        itemName: {
          itself: 'Denumire',
          placeholder: 'Nume material',
        },
        description: {
          itself: 'Descriere',
          placeholder: 'Introduceți descrierea',
        },
        unitOfMeasure: 'U.M.',
        quantity: 'Cantitate',
        unitPrice: 'Preț fără TVA',
        totalPrice: 'Total',
        supplierLink: {
          itself: 'Link furnizor',
          placeholder: 'https://...',
        },
      },
      viewLink: 'Vezi link',
      emptyState: {
        title: 'Niciun material adăugat',
        message: 'Adaugă materiale la această cerere',
        nonDraftTitle: 'Niciun material',
      },
      totalMaterialsCost: 'Cost total materiale',
      addMaterial: 'Adaugă material',
      editMaterial: 'Editează material',
    },
    // Used by InternalRequestCreateForm and EditDraftModal — types.leaveRequest.* is used by detail/admin views
    leaveRequest: {
      employeeLastName: 'Nume',
      employeeFirstName: 'Prenume',
      employeeRole: 'Funcție',
      numberOfDays: 'Număr de zile',
      periodStart: 'Data de început',
      periodEnd: 'Data de sfârșit',
      replacementPerson: 'Înlocuitor',
      employee: 'Angajat',
      selectFromProject: 'Selectează din proiect',
      enterManually: 'Completează manual',
    },
    financialRequest: {
      subType: {
        label: 'Sub-tip',
        loanRequest: 'Cerere împrumut',
        salaryAdvance: 'Avans salariu',
        recruitmentBonus: 'Bonus recrutare',
      },
      requestedAmount: 'Suma solicitată',
      forMonth: 'Pe luna',
      numberOfInstallments: 'Număr de rate lunare',
      monthlyInstallmentAmount: 'Rata lunară',
      referredPersonName: 'Numele persoanei recomandate',
      referredPersonRole: 'Rolul persoanei recomandate',
      bonusAmount: 'Sumă bonus',
    },
    attachments: 'Atașamente',
    uploadAttachments: 'Încarcă atașamente',
    noAttachments: 'Fără atașamente',
    untitled: 'Cerere fără titlu',
    information: 'Informații',
    type: 'Tip',
    amount: 'Sumă',
    statuses: {
      draft: 'Draft',
      submitted: 'Trimis',
      opened: 'Trimis',
      approved: 'Aprobat',
      pendingClosed: 'În curs de închidere',
      rejected: 'Respins',
      closed: 'Închis',
    },
    activity: {
      created: 'Creat',
      submitted: 'Trimis',
      approved: 'Aprobat',
      rejected: 'Respins',
      edited: 'Actualizat',
      attachmentAdded: 'Actualizat',
      commentAdded: 'Actualizat',
      closed: 'Închis',
      assigned: 'Actualizat',
      mfApproved: 'Aprobat MF',
      updated: 'Actualizat',
      createdDescription: 'Cererea a fost creată',
      submittedDescription: 'Cererea a fost trimisă pentru aprobare',
      resubmitted: 'Retrimis',
      resubmittedDescription: 'Cererea a fost retrimisă pentru aprobare',
      approvedDescription: 'Cererea a fost aprobată',
      rejectedDescription: 'Cererea a fost respinsă',
      mfApprovedDescription: 'Cererea a fost aprobată MF',
      assignedDescription: 'Atribuit lui {{name}}',
      closedDescription: 'Referință plată: {{reference}}',
      closedDescriptionGeneric: 'Cererea a fost închisă',
      addExpenseItems: 'Adăugat {{count}} element(e) de cheltuieli',
      updateExpenseItem: 'Actualizat element de cheltuieli',
      deleteExpenseItem: 'Șters element de cheltuieli',
      addMaterialsItems: 'Adăugat {{count}} element(e) de materiale',
      addWorkers: 'Adăugat {{count}} lucrător(i)',
      updateWorker: 'Actualizat lucrător',
      deleteWorker: 'Șters lucrător',
      addFinancialItems: 'Adăugat {{count}} element(e) financiare',
      updateFinancialItem: 'Actualizat element financiar',
      deleteFinancialItem: 'Sters element financiar',
      attachmentRemoved: 'Actualizat',
      updatesCount: '{{count}} actualizări',
      updatesBy: '{{count}} actualizări de {{name}}',
      rejectedNoReason: 'Niciun motiv de respingere furnizat',
      notifications: {
        created: 'creată',
        submitted: 'trimisă',
        approved: 'aprobată',
        rejected: 'respinsă',
        pendingClosed: 'în așteptare închidere',
        closed: 'închisă',
      },
      scope: {
        requestCreated: 'Cerere creată',
        requestUpdated: 'Cerere actualizată.',
        expenseItemsAdded: 'Adăugare Element Cheltuieli',
        expenseItemUpdated: 'Actualizare Element Cheltuieli',
        expenseItemDeleted: 'Ștergere Element Cheltuieli',
        materialItemsAdded: 'Adăugare Element Materiale',
        materialItemUpdated: 'Actualizare Element Materiale',
        materialItemDeleted: 'Ștergere Element Materiale',
        workersAdded: 'Adăugare Lucrător',
        workerUpdated: 'Actualizare Lucrător',
        workerDeleted: 'Ștergere Lucrător',
        financialItemsAdded: 'Adăugare Element Financiar',
        financialItemUpdated: 'Actualizare Element Financiar',
        financialItemDeleted: 'Ștergere Element Financiar',
      },
    },
    generalInformation: 'Informații Generale',
    'generalInformation.subtitle': 'Informații de bază despre cerere',
    hqApprovalQueue: {
      title: 'Coadă Aprobare HQ',
      description: 'Revizuiește și aprobă cereri interne din toate proiectele',
      emptyOpened: {
        title: 'Nicio cerere în așteptare',
        subtitle:
          'Vei fi notificat când apar cereri noi care necesită aprobarea ta',
      },
      emptyApproved: {
        title: 'Nicio cerere în așteptarea aprobării secundare',
        subtitle: 'Cererile care necesită aprobare MF vor apărea aici',
      },
    },
    accountingQueue: {
      title: 'Cereri Interne',
      description: 'Revizuiește și închide cereri interne în așteptarea plății',
      emptyPending: {
        title: 'Totul e la zi!',
        subtitle:
          'Vei fi notificat când apar cereri noi care necesită atenția ta',
      },
      emptyClosed: {
        title: 'Nicio cerere închisă încă',
        subtitle: 'Cererile pe care le închizi vor apărea aici',
      },
    },
    tabs: {
      requiresAttention: 'Necesită Atenție',
      submitted: 'Trimise',
      approved: 'Aprobate',
      pendingClose: 'În așteptare închidere',
      closed: 'Închise',
      rejected: 'Respinse',
    },
    adminQueue: {
      emptyRequiresAttention: {
        title: 'Totul e la zi!',
        subtitle: 'Nicio cerere nu necesită atenția ta în acest moment',
      },
      emptySubmitted: {
        title: 'Nicio cerere trimisă',
        subtitle: 'Cererile trimise vor apărea aici',
      },
      emptyApproved: {
        title: 'Nicio cerere aprobată',
        subtitle: 'Cererile aprobate în așteptare vor apărea aici',
      },
      emptyPendingClose: {
        title: 'Nicio cerere în așteptarea închiderii',
        subtitle: 'Cererile în așteptarea închiderii vor apărea aici',
      },
      emptyClosed: {
        title: 'Nicio cerere închisă',
        subtitle: 'Cererile închise vor apărea aici',
      },
      emptyRejected: {
        title: 'Nicio cerere respinsă',
        subtitle: 'Cererile respinse vor apărea aici',
      },
      empty: {
        title: 'Nicio cerere găsită',
        subtitle: 'Cererile interne vor apărea aici',
      },
      seeAll: 'Vezi toate',
    },
    error: {
      loading: 'Eroare la încărcarea cererii interne',
    },
    actions: {
      send: 'Trimite',
      edit: 'Editează',
      delete: 'Șterge',
      approve: 'Aprobă',
      reject: 'Respinge',
      mfApprove: 'Aprobă',
      close: 'Închide',
    },
    rejectReason: 'Motivul respingerii (opțional)',
    rejectReasonPlaceholder: 'Introdu un motiv pentru respingere...',
    confirmModals: {
      confirmApproveMessage: 'Ești sigur că vrei să aprobi această {{type}}?',
      confirmMfApproveMessage:
        'Ești sigur că vrei să aprobi această {{type}}? (nivelul 2)',
      confirmRejectMessage: 'Ești sigur că vrei să respingi această {{type}}?',
      approveAmountLabel: 'Sumă de aprobat',
      approveAmountDisplay: 'Sumă totală',
      approveAmountRequired: 'O sumă validă este necesară',
      rejectReasonPlaceholder: 'Introdu un motiv pentru respingere...',
      reasonRequired: 'Un motiv este obligatoriu',
      cancel: 'Nu, anulează',
      confirmReject: 'Da, respinge!',
      confirmApprove: 'Da, aprobă!',
      confirmMfApprove: 'Da, aprobă!',
      approvedDaysRequired:
        'Zilele aprobate sunt obligatorii și trebuie să fie cel puțin 1',
      invalidNumber: 'Trebuie să fie un număr valid, pozitiv',
      approverNotesLabel: 'Mențiuni aprobator',
      approverNotesPlaceholder:
        'Introduceți mențiuni pentru această aprobare...',
      resubmissionNoteTitle: 'Notă de retrimitere',
      resubmissionNotePlaceholder:
        'Explicați ce s-a modificat după respingere...',
      resubmissionNoteRequired: 'Nota de retrimitere este obligatorie',
      resubmissionNoteConfirm: 'Retrimite',
      actionCommentTitle: 'Comentariu (opțional)',
      actionCommentPlaceholder: 'Adaugă context pentru această acțiune...',
      actionCommentConfirm: 'Confirmă',
    },
    validation: {
      currencyRequired: 'Moneda este obligatorie',
      expenseItemsRequired:
        'Cel puțin un element de cheltuieli este obligatoriu',
      claimPeriodStartRequired: 'Data de început a perioadei este obligatorie',
      claimPeriodEndRequired: 'Data de sfârșit a perioadei este obligatorie',
      paymentMethodRequired: 'Metoda de plată este obligatorie',
      materialsRequired: 'Cel puțin un material este obligatoriu',
      workersOrFinancialRequired:
        'Este necesar cel puțin un muncitor sau o poziție de date financiare',
      ewaSubTypeRequired: 'Tipul este obligatoriu',
      workersRequired: 'Cel puțin un muncitor este necesar',
      financialItemsRequired: 'Cel puțin un element financiar este necesar',
      financialItemsRequiredWhenMarked:
        'Datele financiare sunt marcate ca prezente, dar nu au fost adăugate elemente financiare.',
      invoiceNotCollected:
        'Vă rugăm să verificați în Priority dacă factura a fost încasată',
      financialRequestAmountRequired: 'Suma solicitată este obligatorie',
      financialRequestAmountPositive:
        'Suma solicitată trebuie să fie mai mare decât 0',
      financialRequestForMonthRequired: 'Luna este obligatorie',
      financialRequestInstallmentsRequired: 'Numărul de rate este obligatoriu',
      financialRequestReferredNameRequired:
        'Numele persoanei recomandate este obligatoriu',
      financialRequestReferredRoleRequired:
        'Rolul persoanei recomandate este obligatoriu',
      financialRequestSubTypeRequired: 'Sub-tipul este obligatoriu',
      leaveRequestDaysRequired: 'Numărul de zile este obligatoriu',
      leaveRequestDaysPositive:
        'Numărul de zile trebuie să fie mai mare decât 0',
      leaveRequestPeriodStartRequired: 'Data de început este obligatorie',
      leaveRequestPeriodEndRequired: 'Data de sfârșit este obligatorie',
      leaveRequestPeriodEndInvalid:
        'Data de sfârșit trebuie să fie după data de început',
      leaveRequestLastNameRequired: 'Numele este obligatoriu',
      leaveRequestFirstNameRequired: 'Prenumele este obligatoriu',
    },
    messages: {
      submittedSuccess: 'Cerere trimisă cu succes',
      submitError: 'Eroare la trimiterea cererii',
      approvedSuccess: 'Cerere aprobată cu succes',
      approveError: 'Eroare la aprobarea cererii',
      rejectedSuccess: 'Cerere respinsă cu succes',
      rejectError: 'Eroare la respingerea cererii',
      mfApprovedSuccess: 'Cerere aprobată de MF cu succes',
      mfApproveError: 'Eroare la aprobarea MF',
      closedSuccess: 'Cerere închisă cu succes',
      closeError: 'Eroare la închiderea cererii',
      selectHqUser:
        'Te rugăm să selectezi un utilizator HQ pentru a atribui această cerere',
      lineItemAdded: 'Element adăugat cu succes',
      lineItemUpdated: 'Element actualizat cu succes',
      lineItemDeleted: 'Element șters cu succes',
      lineItemError: 'Eroare la salvarea elementului',
      draftUpdated: 'Draftul a fost actualizat cu succes',
      updateError: 'Eroare la actualizarea cererii',
      draftDeleted: 'Draftul a fost șters cu succes',
      deleteError: 'Eroare la ștergerea cererii',
      exportDocumentError: 'Exportul documentului a eșuat',
    },
    assignToHqUser: 'Atribuie unui utilizator HQ',
    assignToNextHqUser: 'Atribuie următorului utilizator HQ',
    details: 'Detalii',
    createdAt: 'Creată la',
    requestedBy: 'Solicitant',
    approver: 'Aprobator',
    neededByDate: {
      itself: 'Necesar până la',
    },
    description: {
      itself: 'Descriere',
    },
    requestedAmount: {
      itself: 'Sumă Solicitată',
    },
    noDetails: 'Nu există detalii suplimentare',
    claimPeriodStart: {
      itself: 'Început Perioadă',
    },
    claimPeriodEnd: {
      itself: 'Sfârșit Perioadă',
    },
    totalAmount: {
      itself: 'Sumă Totală',
    },
    advanceReceived: {
      itself: 'Avans primit',
    },
    lineItem: {
      description: {
        itself: 'Descriere',
      },
      amount: {
        itself: 'Sumă',
      },
      date: {
        itself: 'Data',
      },
      name: {
        itself: 'Nume',
      },
      quantity: {
        itself: 'Cantitate',
      },
      unit: {
        itself: 'Unitate',
      },
      estimatedCost: {
        itself: 'Cost estimat',
      },
    },
    loanPurpose: {
      itself: 'Scopul Împrumutului',
    },
    repaymentDurationMonths: {
      itself: 'Durata rambursării',
    },
    numberOfInstallments: {
      itself: 'Număr de Rate',
    },
    monthlyInstallmentAmount: {
      itself: 'Rata lunară',
    },
    startMonth: {
      itself: 'Data de Început',
    },
    purpose: {
      itself: 'Scop',
    },
    expectedReturnDate: {
      itself: 'Data estimată de returnare',
    },
    workDescription: {
      itself: 'Descrierea lucrărilor',
    },
    justification: {
      itself: 'Justificare',
    },
    estimatedCost: {
      itself: 'Cost Estimat',
    },
    startDate: {
      itself: 'Data Început',
    },
    endDate: {
      itself: 'Data sfârșit',
    },
    workDate: {
      itself: 'Data lucrărilor',
    },
    startTime: {
      itself: 'Ora Început',
    },
    endTime: {
      itself: 'Ora sfârșit',
    },
    totalHours: {
      itself: 'Total ore',
    },
    reason: {
      itself: 'Motiv',
    },
    urgencyLevel: {
      itself: 'Nivel de Urgență',
    },
    deliveryLocation: {
      itself: 'Locație Livrare',
    },
    activityLog: {
      title: 'Istoric activitate',
      created: 'a creat această cerere',
      submitted: 'a trimis pentru aprobare',
      approved: 'a aprobat această cerere',
      rejected: 'a respins această cerere',
      edited: 'a editat această cerere',
      attachmentAdded: 'a adăugat un atașament',
      commentAdded: 'a adăugat un comentariu',
      closed: 'a închis această cerere',
      assigned: 'a reatribuit această cerere',
    },
    noActivity: 'Nicio activitate încă',
    pendingApprover: 'În așteptare',
    rejectionReason: 'Motiv respingere',
    editDraft: 'Editează Draft',
    deleteDraft: {
      title: 'Șterge Draft',
      message:
        'Ești sigur că vrei să ștergi acest draft? Această acțiune nu poate fi anulată.',
    },
    worker: {
      lastName: 'Nume',
      lastNamePlaceholder: 'Introdu numele',
      firstName: 'Prenume',
      firstNamePlaceholder: 'Introdu prenumele',
      role: 'Funcție',
      rolePlaceholder: 'Introdu funcția',
      amount: 'Sumă',
      addWorker: 'Adaugă muncitor',
      editWorker: 'Editează muncitor',
    },
    financial: {
      documentNumber: 'Nr. document',
      documentNumberPlaceholder: 'ex. PQ25003035',
      documentDate: 'Data document',
      valueWithoutVat: 'Valoare (fără TVA)',
      invoiceNumber: 'Nr. factură',
      invoiceNumberPlaceholder: 'ex. INV-2025-001',
      invoiceDate: 'Data factură',
      isInvoiced: 'Facturat',
      isCollected: 'Încasat',
      addFinancialItem: 'Adaugă element financiar',
      editFinancialItem: 'Editează element financiar',
    },
    addNewIssuer: 'Adaugă emitent nou',
    addNewExpenseCategory: 'Adaugă categorie nouă',
    addNewLastName: 'Adaugă nume nou',
    addNewFirstName: 'Adaugă prenume nou',
    addNewRole: 'Adaugă funcție nouă',
    addNewItemName: 'Adaugă denumire nouă',
    addNewMaterialDescription: 'Adaugă descriere nouă',
    unitOfMeasure: {
      piece: 'Bucată (buc.)',
      hour: 'Oră',
      day: 'Zi',
      month: 'Lună',
      kilogram: 'Kilogram (kg)',
      gram: 'Gram (g)',
      liter: 'Litru (L)',
      meter: 'Metru (m)',
      squareMeter: 'Metru pătrat (m²)',
      cubicMeter: 'Metru cub (m³)',
      package: 'Pachet',
      box: 'Cutie',
      set: 'Set',
    },
    unitOfMeasureShort: {
      piece: 'buc.',
      hour: 'oră',
      day: 'zi',
      month: 'lună',
      kilogram: 'kg',
      gram: 'g',
      liter: 'L',
      meter: 'm',
      squareMeter: 'm²',
      cubicMeter: 'm³',
      package: 'pachet',
      box: 'cutie',
      set: 'set',
    },
    export: {
      title: 'Exportă cereri interne',
      buttonLabel: 'Export',
      fileName: 'Nume fișier',
      fileNameRequired: 'Numele fișierului este obligatoriu',
      startDate: 'Data început',
      endDate: 'Data sfârșit',
      endDateAfterStart:
        'Data sfârșit trebuie să fie egală sau ulterioară datei început',
      types: 'Tip',
      typesRequired: 'Cel puțin un tip este obligatoriu',
      statuses: 'Status',
      statusesRequired: 'Cel puțin un status este obligatoriu',
      all: 'Toate',
      project: 'Proiect',
      allProjects: 'Toate proiectele',
      success: 'Exportul a fost descărcat',
    },
  },
};
